import { Button, Space } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

const BulkDeletePopup = ({ selectedRows, handleDelete }) => {
  return (
    <div
      className=" bg-white shadow-lg d-flex align-items-center justify-content-end px-4"
      style={{
        position: "fixed",
        bottom: selectedRows.length > 0 ? "0px" : "-80px",
        transition: "bottom 0.3s ease",
        zIndex: 1000,
        width: "calc(100% - 280px)"
      }}
    >
      <Space size="middle" className="p-3">
        <Button
          danger
          icon={<DeleteOutlined />}
          onClick={handleDelete}
          style={{ borderRadius: "8px" }}
        >
          Delete
        </Button>
      </Space>
    </div>
  );
};

export default BulkDeletePopup;
